import { MemberDatasource } from './datasources/member_datasource';
import { IDisplayMessageService } from './services/display_message_service';
import { IProgression } from 'utility-js-progression';
import { IPhxAxTitleAnnouncerDelegate } from './types';
import { ICommand } from 'core-ts-types';
import { GlobalRouteConfiguration } from './configuration/route_configuration';

angular
  .module('capability-ng-global', [
    'ngSanitize',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'ct.ui.router.extras.core',
    'ct.ui.router.extras.dsr',
    'ct.ui.router.extras.sticky',
    'vendor'
  ])
  .run(function(
    loadMemberConfigurationCommand: ICommand,
    loadDisplayMessagesCommand: ICommand,
    initializeAnonymousUserActivityCommand: ICommand,
    initializeGoogleTagManagerCommand: ICommand,
    phxAxTitleAnnouncerDelegate: IPhxAxTitleAnnouncerDelegate,
    ngTransferCreditsProgression: IProgression,
    ngMemberDatasource: MemberDatasource,
    ngDisplayMessageService: IDisplayMessageService,
    $document: ng.IDocumentService
  ): void {
    const promises = [loadMemberConfigurationCommand(), loadDisplayMessagesCommand()];
    Promise.all(promises)
      .then(() => {
        const coreConfig = ngMemberDatasource.read().core_config;
        phxAxTitleAnnouncerDelegate.announceTitle(`Transfer to ${coreConfig.short_name}`);
        ngTransferCreditsProgression.source.major.displayName = `My ${coreConfig.short_name} Major`;

        ngTransferCreditsProgression.source.past.displayName = ngDisplayMessageService('colleges_tab_name').text;
        ngTransferCreditsProgression.source.exam.displayName = ngDisplayMessageService('other_credits_tab_name').text;

        const faviconId: string = 'mf_favicon';
        const faviconUrl = _.get(ngMemberDatasource.read(), 'branding.favicon', '');
        const head = $document.find('head')[0];
        const existingLink = $document.find(`#${faviconId}`);

        if (!existingLink.length) {
          const link = document.createElement('link');

          link.type = 'image/png';
          link.rel = 'shortcut icon';
          link.id = faviconId;
          link.href = faviconUrl;

          head.appendChild(link);
        }

        if (coreConfig) {
          const meta = document.createElement('meta');
          meta.name = 'description';
          meta.content = `Transfer to ${coreConfig.full_name}`;
          
          const script = document.createElement('script');
          script.type = "application/ld+json";
          script.innerHTML = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            'name': coreConfig.full_name,
            'alternateName': coreConfig.short_name,
            'url': coreConfig.university_url
          });

          document.head.appendChild(script);
          document.head.appendChild(meta);
        }
      })
      .finally(() => {
        initializeGoogleTagManagerCommand();
        initializeAnonymousUserActivityCommand();
      });
  })
  .config((ngGlobalRouteConfigurationProvider: GlobalRouteConfiguration) => {
    ngGlobalRouteConfigurationProvider.state();
  });



// WEBPACK FOOTER //
// ./app/lib/global/core.ts